"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var ENDPOINT_URL = '/shopping/v3/orders/merchandise';
var quantityUpgradesApi = {
  post: function post(data) {
    return _apiClient.default.post(ENDPOINT_URL, {
      data: data
    }).then(function (purchaseOrder) {
      return purchaseOrder.id;
    });
  }
};
var _default = quantityUpgradesApi;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/core/api/quantityUpgradesApi.js
// module id = 720
// module chunks = 5 6